

















import { SXChoice } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";

const getForm = function() {
	return {
		fields: {
			others_choice: {
				field: "checkbox",
				label: { i18n: "SX_LANG_ADD_OTHERS_CHOICE" },
				attrs: {
					name: "others_choice"
				},
				i18n: "SX_LANG_ADD_OTHERS_CHOICE"
			}
		}
	};
};

@Component
export default class WQtypeRadio extends BaseComponent {
	@Prop({ type: Object, required: true })
	options!: any;

	get form() {
		return getForm();
	}

	@Watch("options.choices", { deep: true })
	watchOptionsChoices() {
		this.onOptionsChange();
	}

	@Emit("type-state-change")
	onOptionsChange() {
		return this.checkChoices();
	}

	checkChoices() {
		let len = this.options.choices.length,
			state = !!len,
			i;

		for (i = 0; i < len; i++) {
			let ch: SXChoice = this.options.choices[i];
			if (!ch.label.length) {
				state = false;
				break;
			}
		}

		return state;
	}

	toggleOthersChoice($e: any) {
		this.options.othersChoice = !!$e.target.checked;
	}

	mounted() {
		this.onOptionsChange();
	}
}
